import { IDirectoryRecord } from "../directory.state";

export interface IExternalDirectoryRecord extends IDirectoryRecord {
    priority?: boolean;
    createdTime?: number;
    lastUpdatedTime?: number;
    externalId?: string;
    isSensitive?: boolean;
    custom?: {
        [key: string]: any;
    };
}

export type binary = 0 | 1;

export interface IExternalDirectoryCustomField {
    name: string;
    label: string;
    type: "list" | "text";
}

export enum IExternalDirectoryActionTypes {
    SET_EXTERNAL_DIRECTORY = "GET_DIRECTORY",
    EXTERNAL_DIRECTORY_LOADING = "GET_DIRECTORY_LOADING",
    DELETE_EXTERNAL_DIRECTORY_ITEM = "DELETE_DIRECTORY_ITEM",
    DELETE_EXTERNAL_DIRECTORY_ITEM_LOADING = "DELETE_DIRECTORY_ITEM_LOADING",
    ADD_EXTERNAL_DIRECTORY_ITEM = "ADD_DIRECTORY_ITEM",
    EDIT_EXTERNAL_DIRECTORY_ITEM = "EDIT_DIRECTORY_ITEM",
    EDIT_EXTERNAL_DIRECTORY_ITEM_LOADING = "EDIT_DIRECTORY_ITEM_LOADING",
    EXTERNAL_DIRECTORY_ERROR = "EXTERNAL_DIRECTORY_ERROR",
    SET_MANAGE_EXTERNAL_DIRECTORY_SEARCH_PARAMS = "SET_MANAGE_EXTERNAL_DIRECTORY_SEARCH_PARAMS",
}

export interface IManageExternalDirectorySearchParams {
    priority?: boolean;
    owner?: string;
    search?: string;
}

export interface IExternalDirectory {
    contacts: IExternalDirectoryRecord[];
    isLoading?: boolean;
    editContactLoading: boolean;
    deleteContactLoading: boolean;
    errors: string[];
    manageExternalDirectorySearchParams: IManageExternalDirectorySearchParams;
}
